var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addon-modal-page", on: { click: _vm.closeModal } },
    [
      _c(
        "div",
        {
          ref: "addonModal",
          staticClass: "addon-modal-container",
          attrs: { id: "addonModal" },
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("img", {
            staticClass: "x",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
              alt: "x"
            },
            on: {
              click: function($event) {
                return _vm.closeModal()
              }
            }
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "back",
              on: {
                click: function($event) {
                  return _vm.closeModal()
                }
              }
            },
            [_vm._v("< BACK")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "addon-container" }, [
            _c("div", { staticClass: "images-container" }, [
              _vm.mainBadge != null
                ? _c("span", { staticClass: "main-badge" }, [
                    _vm._v(_vm._s(_vm.mainBadge))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("img", {
                staticClass: "main-image",
                attrs: { src: _vm.currentMainImage }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "extra-images-container" },
                [
                  _c(
                    "Flicking",
                    {
                      ref: "flicking",
                      attrs: {
                        options: {
                          align: "prev",
                          circular: true,
                          preventDefaultOnDrag: true,
                          preventClickOnDrag: true,
                          renderOnlyVisible: true,
                          horizontal: false
                        }
                      }
                    },
                    _vm._l(_vm.selectedAddon.images, function(image) {
                      return _c("img", {
                        key: image.id,
                        staticClass: "extra-image lazyload",
                        class:
                          image.src == _vm.currentMainImage ? "selected" : "",
                        attrs: { src: image.src },
                        on: {
                          click: function($event) {
                            return _vm.selectImage(image.src)
                          }
                        }
                      })
                    }),
                    0
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "data-container" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.selectedAddon.title))
              ]),
              _vm._v(" "),
              _vm.ethosTags.length > 0 || _vm.showOnDemand
                ? _c(
                    "div",
                    { staticClass: "ethos-container" },
                    [
                      _vm._l(_vm.ethosTags, function(etho) {
                        return _c(
                          "span",
                          { key: etho, class: _vm.badgeExtraClass(etho) },
                          [_vm._v(_vm._s(etho))]
                        )
                      }),
                      _vm._v(" "),
                      _vm.showOnDemand
                        ? _c("span", { staticClass: "purple-ethos" }, [
                            _vm._v("Ships in 1-2 weeks")
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticClass: "desc-label" }, [_vm._v("Description")]),
              _vm._v(" "),
              _c("p", {
                staticClass: "desc",
                domProps: { innerHTML: _vm._s(_vm.productDesc) }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "alergen-container" },
                _vm._l(_vm.dietaryTags, function(dietary) {
                  return _c("span", { key: dietary }, [_vm._v(_vm._s(dietary))])
                }),
                0
              ),
              _vm._v(" "),
              _vm.allergens
                ? _c("div", { staticClass: "ingredient-container" }, [
                    _c("p", [
                      _c("strong", [_vm._v("ALLERGENS:")]),
                      _vm._v(" " + _vm._s(_vm.allergens))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasVariants
                ? _c("div", { staticClass: "variant-container" }, [
                    _c("p", { staticClass: "variant-title" }, [
                      _vm._v("Choose options:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sizes-selection-container" },
                      _vm._l(_vm.displaySizes, function(variant, i) {
                        return _c("div", { staticClass: "size-selection" }, [
                          _c("p", [_vm._v(_vm._s(variant.name))]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.displaySizes[i].qty,
                                expression: "displaySizes[i].qty"
                              }
                            ],
                            attrs: {
                              min: "0",
                              max: variant.maxQty,
                              type: "number"
                            },
                            domProps: { value: _vm.displaySizes[i].qty },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.displaySizes[i],
                                    "qty",
                                    $event.target.value
                                  )
                                },
                                function($event) {
                                  return _vm.validateVariantQty(i)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _vm.selectedAddon.corporate
                            ? _c("p", { staticClass: "in-stock" }, [
                                _vm._v(_vm._s(variant.maxQty) + " in stock")
                              ])
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.customAlert != ""
                ? _c("p", {
                    staticClass: "red-alert",
                    domProps: { innerHTML: _vm._s(_vm.customAlert) },
                    on: { click: _vm.changeMinBoxQty }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.hasVariants
                ? _c(
                    "button",
                    {
                      staticClass: "happybox-button green border",
                      on: {
                        click: function($event) {
                          return _vm.updateVariantsQty()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.variantsTotal ? "Update box" : "Add to box")
                      )
                    ]
                  )
                : _vm.currentQty == 0
                ? _c(
                    "button",
                    {
                      staticClass: "happybox-button green border",
                      on: {
                        click: function($event) {
                          return _vm.updateMainAddonProductQuantity(1)
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.addCopy) +
                          " - " +
                          _vm._s(_vm._f("moneySaleFormat")(_vm.productPrice)) +
                          " "
                      )
                    ]
                  )
                : _vm.currentQty > 0 && _vm.manualInput == false
                ? _c("div", { staticClass: "selector-container" }, [
                    _c("div", { staticClass: "selector-shown" }, [
                      _c(
                        "div",
                        {
                          staticClass: "quantity-show",
                          on: { click: _vm.openSelector }
                        },
                        [
                          _c("i", { staticClass: "arrow down" }),
                          _c("span", [
                            _vm._v("QTY / BOX "),
                            _c("br"),
                            _vm._v(" " + _vm._s(_vm.currentQty))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "separator" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "box-show" }, [
                        _vm._v(" IN BOX")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.isSelectorOpen == true
                      ? _c(
                          "div",
                          { staticClass: "selector-options" },
                          [
                            _vm._l(_vm.addonMaxSelectors, function(qty) {
                              return _c(
                                "button",
                                {
                                  key: qty,
                                  on: {
                                    click: function($event) {
                                      return _vm.onSelectorValueChange(qty)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(qty) + " in a box")]
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "custom",
                                on: {
                                  click: function($event) {
                                    return _vm.onSelectorValueChange("custom")
                                  }
                                }
                              },
                              [_vm._v("Custom Amount")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "remove",
                                on: {
                                  click: function($event) {
                                    return _vm.onSelectorValueChange("remove")
                                  }
                                }
                              },
                              [_vm._v("Remove from box")]
                            )
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                : _c("div", { staticClass: "input-container" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.manualInputQty,
                          expression: "manualInputQty"
                        }
                      ],
                      attrs: { min: 1, max: _vm.productMaxQty, type: "number" },
                      domProps: { value: _vm.manualInputQty },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.manualInputQty = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "happybox-button green border",
                        on: {
                          click: function($event) {
                            return _vm.updateMainAddonProductQuantity(
                              _vm.manualInputQty
                            )
                          }
                        }
                      },
                      [_vm._v(" UPDATE BOX")]
                    )
                  ])
            ])
          ]),
          _vm._v(" "),
          _vm.recommendedAddons.length > 0
            ? _c("div", { staticClass: "recommendation-container" }, [
                _c("div", {
                  staticClass: "arrow left",
                  on: {
                    click: function($event) {
                      return _vm.scroll(true)
                    }
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "title" }, [_vm._v("Add more gifts:")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "side-scroller",
                    attrs: { id: "sideScroller" }
                  },
                  _vm._l(_vm.recommendedAddons, function(addon) {
                    return _c(
                      "div",
                      { key: addon.id, staticClass: "recommended-addon" },
                      [
                        _c("img", {
                          staticClass: "main-image",
                          attrs: { src: _vm._f("getProductImage")(addon) },
                          on: {
                            click: function($event) {
                              return _vm.changeAddon(addon)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "happybox-button white border",
                            on: {
                              click: function($event) {
                                return _vm.updateReccomendedAddonProductQuantity(
                                  addon
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.addCopy))]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "addon-title" }, [
                          _vm._v(_vm._s(addon.title))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "price" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moneySaleFormat")(addon.variants[0].price)
                            )
                          )
                        ])
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "arrow right",
                  on: {
                    click: function($event) {
                      return _vm.scroll(false)
                    }
                  }
                })
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }